import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuncionalidadControl } from '../../_models/funcionalidad-control';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ProductoEstadoRelacionService } from '../../_services/producto-estado-relacion.service';
import { ListaService } from '../../_services/lista.service';
import { ProductoEstadoRelacionCausalService } from '../../_services/producto-estado-relacion-causal.service';
import { TipoCausalCausalSolicitudService } from '../../_services/tipo-causal-causal-solicitud.service';
import { FuncionalidadesService } from '../../_services/funcionalidades.service';
import { ProductoEstadoRelacionNotificacionService } from '../../_services/producto-estado-relacion-notificacion.service';
import { NotificacionesService } from '../../_services/notificaciones.service';
import { forkJoin } from 'rxjs';
import { CanalService } from '../../_services/canal.service';
import { EstadoService } from '../../_services/estado.service';
import { ConfiguracionesCanales } from '../../_models/configuraciones-canales';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfiguracionesCanalesService } from '../../_services/configuraciones-canales.service';
import { Location } from '@angular/common';
import moment from 'moment';
import 'moment/locale/es';
import {AutenticacionService} from '../../_services/autenticacion.service';

@Component( {
  selector: 'app-canal-estado-detalle',
  templateUrl: 'canal-estado-detalle.component.html'
} )

export class CanalEstadoDetalleComponent implements OnInit {

  canalSeleccionada: ConfiguracionesCanales;
  cargando = true;

  constructor( private configuracionCanalServicio: ConfiguracionesCanalesService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService,
               private route: ActivatedRoute,
               private location: Location
               ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.configuracionCanalServicio.obtenerPorId(params[ 'id' ]).subscribe(data => {
          this.canalSeleccionada = data;
          this.cargando = false;
        });
      }
    } );
  }





  regresar() {
    this.location.back();
  }



}
